<script setup lang="ts">
withDefaults(
  defineProps<{
    size?: number | string;
    color?: string;
    weight?: "regular" | "bold";
  }>(),
  {
    size: 24,
    color: "currentColor",
    weight: "regular",
  }
);
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    :width="size"
    :height="size"
    :fill="color"
    v-bind="$attrs"
  >
    <path
      v-if="weight === 'regular'"
      d="M19.3636 20.6364C19.7151 20.9878 20.2849 20.9878 20.6364 20.6364C20.9879 20.2849 20.9879 19.7151 20.6364 19.3636L13.2728 12L20.6364 4.63637C20.9879 4.2849 20.9879 3.71505 20.6364 3.36358C20.2849 3.01211 19.7151 3.01211 19.3636 3.36358L12 10.7272L4.6364 3.36358C4.28493 3.01211 3.71508 3.01211 3.36361 3.36358C3.01214 3.71505 3.01214 4.2849 3.36361 4.63637L10.7272 12L3.36361 19.3636C3.01214 19.7151 3.01214 20.2849 3.36361 20.6364C3.71508 20.9878 4.28493 20.9878 4.6364 20.6364L12 13.2728L19.3636 20.6364Z"
    />
    <path
      v-else-if="weight === 'bold'"
      d="M18.9393 21.0607C19.5251 21.6464 20.4749 21.6464 21.0607 21.0607C21.6464 20.4749 21.6464 19.5251 21.0607 18.9393L14.1213 12L21.0607 5.06066C21.6464 4.47487 21.6464 3.52513 21.0607 2.93934C20.4749 2.35355 19.5251 2.35355 18.9393 2.93934L12 9.87868L5.06066 2.93934C4.47487 2.35355 3.52513 2.35355 2.93934 2.93934C2.35355 3.52513 2.35355 4.47487 2.93934 5.06066L9.87868 12L2.93934 18.9393C2.35355 19.5251 2.35355 20.4749 2.93934 21.0607C3.52513 21.6464 4.47487 21.6464 5.06066 21.0607L12 14.1213L18.9393 21.0607Z"
    />
  </svg>
</template>
